// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__1PRng","box":"WorkspacesBox_box__2SHM9","node":"WorkspacesBox_node__109Lb"};